import { FC, Fragment, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

import { useAppDispatch, useAppSelector } from "redux/hooks";
import { ResetLoginError } from "redux/slices/LoginSlice";

import { Panel, PasswordBlockModal } from "components";
import Tab from "components/BaseComponents/Tab";
import CorporateLogin from "./CorporateLogin";
import IndividualLogin from "./IndividualLogin";
import { DIGIPOSTHEME } from "theme/digiPosTheme";
import { Row } from "components/BaseComponents/Flex";
import InfoCallCenter from "../InfoCallCenter";

const Login: FC = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const refScroll = useRef<HTMLHeadElement | null>(null);

  const [isPassBlockModalOpen, setIsPassBlockModalOpen] = useState<boolean>(
    false
  );

  // const [lockedMessage, setLockedMessage] = useState<string>("");

  const { user } = useAppSelector((state) => state.login);

  useEffect(() => {
    if (user && user.IsIgsLocked) {
      setIsPassBlockModalOpen(true);
      // setLockedMessage(user.DialogBoxes[0]?.Message);
    }
  }, [user]);

  useEffect(() => {
    if (refScroll?.current) {
      setTimeout(function () {
        refScroll.current?.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }, 100);
    }
  }, []);

  const tabHandler = () => {
    dispatch(ResetLoginError());
  };

  return (
    <Fragment>
      <section
        ref={refScroll}
        id='Login-section'
        style={{ position: "absolute", top: 0, scrollBehavior: "smooth" }}
      />
      <Panel width='646px' marginTop='0'>
        <Tab
          onTabChange={tabHandler}
          tabList={[
            {
              tabElement: () => <IndividualLogin />,
              tabHeader: t("individual").toString(),
              tabInfo: "",
            },
            {
              tabElement: () => <CorporateLogin />,
              tabHeader: t("corporate").toString(),
              tabInfo: "",
            },
          ]}
        />
        <Row backgroundColor={DIGIPOSTHEME.colors.secondaryWhite} noMargin>
          <InfoCallCenter />
        </Row>
      </Panel>

      {isPassBlockModalOpen && (
        <PasswordBlockModal
          acceptButtonText={t("modal_error_button_title").toString()}
          message={t("user_admin_agent_lock_password").toString()} //{lockedMessage}
          setIsOpen={setIsPassBlockModalOpen}
          title={t("information").toString()}
        />
      )}
    </Fragment>
  );
};

export default Login;
